import { FC } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { DeloitteText } from '../Deloitte';
import { MoreVert } from '@mui/icons-material';


const useStyles = makeStyles({
    itemTitle: {
        fontWeight: 300,
        fonsSize: '32px',
        lineHeight: '42px',
        marginBottom: '18px',
        marginTop: '18px'
    },
    itemIndex: {
        fontWeight: 300,
        fonsSize: '32px',
        lineHeight: '42px',
        margin: "0 18px 18px 18px",
        textAlign: 'center'
    },
    icon: {
        fontSize: '60px',
        fontWeight: 300
    },
    more: {
        fontSize: '34px'
    }
});

interface MethodItemProps {
    icon: any;
    title: string;
    text: string;
    index: number;
    isLast?: boolean;
}

export const MethodItem: FC<MethodItemProps> = (props) => {
    const classes = useStyles();
    const { title, icon, text, index, isLast } = props;
    const Icon = icon;
    return (
        <Grid container direction="row" spacing={2}>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Grid>
                    <Icon className={classes.icon} />
                </Grid>
                {!isLast &&
                    <Grid>
                        <MoreVert className={classes.more} />
                    </Grid>
                }
            </Grid>
            <Grid xs={1} sx={
                {
                    display: {
                        xs: 'none',
                        md: 'inline'
                    }
                }
            }>
                <Typography variant="h4" className={classes.itemIndex} color="secondary">{index}.</Typography>
            </Grid>
            <Grid container xs direction="row">
                <Grid xs={12} flexShrink={1}>
                    <Typography variant="h4" className={classes.itemIndex} color="secondary" sx={{ display: { xs: 'inline', md: 'none' } }} component='span'>{index}.</Typography>
                    <Typography variant="h4" className={classes.itemTitle} component='span'>{title}</Typography>
                </Grid>
                <Grid xs={12}>
                    <DeloitteText>{text}</DeloitteText>
                </Grid>
            </Grid >
        </Grid >
    );
}
